//Parametre olarak seriesId veya lineId veya plate  classı alır.
import React, { useEffect, useState } from 'react'
import { Card, Image, Modal, Skeleton } from 'antd'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import RdwSection from './RdwSection'
import fetchVehicleInfo from '@/core/vehicle/fetchVehicleInfo'
import getCatalogName from '@/helpers/getCatalogName'
const clearPlate = (Plate) => {
  try {
    return Plate.toUpperCase().replaceAll(' ', '').replaceAll('-', '')
  } catch (e) {
    return ''
  }
}


function formatDate(dateString) {

  // 1. Uzunluk kontrolü
  try {
    if (dateString.length !== 8) {
      return {
        success: false,
        message: "Invalid date format: Input should be 8 characters long.",
        originalInput: dateString
      };
    }

    // 2. Sadece rakamlardan oluşup oluşmadığını kontrol et
    if (!/^\d{8}$/.test(dateString)) {

      return {
        success: false,
        message: "Invalid date format: Input should contain only digits.",
        originalInput: dateString
      };
    }

    // 3. Yıl, ay ve günü ayır
    const year = parseInt(dateString.slice(0, 4), 10);
    const month = parseInt(dateString.slice(4, 6), 10);
    const day = parseInt(dateString.slice(6, 8), 10);

    // 4. Geçerli bir ay kontrolü (1-12)
    if (month < 1 || month > 12) {

      return {
        success: false,
        message: "Invalid date: Month should be between 01 and 12.",
        originalInput: dateString
      };
    }

    // 5. Geçerli bir gün kontrolü (1-31, ay bazında doğrulama ile)
    const daysInMonth = new Date(year, month, 0).getDate(); // Ayın gün sayısını al
    if (day < 1 || day > daysInMonth) {
      return {
        success: false,
        message: `Invalid date: Day should be between 01 and ${daysInMonth} for month ${month}.`,
        originalInput: dateString
      };
    }

    // 6. Başarılı ise formatlanmış tarihi döndür
    return {
      success: true,
      originalInput: `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`,
    }
  } catch (e) {
    console.log({ e });
    return {
      success: false,
      message: "Invalid date format: Input should be 8 characters long.",
      originalInput: dateString
    };
  }
}

const RdwLogo = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={98} height={33} viewBox="0 0 98 33" fill="none" {...props}>
    <path
      d="m50.3 11.733-9.117-4.501h-.002c-.666.085-1.423.201-2.04.306l6.202 2.689c-.175.076-.245.1-.395.164l-6.604-2.71a48.992 48.992 0 0 0-3.604.802l5.93 1.918c-.275.127-.349.162-.633.295l-6.412-1.921c-1.906.532-3.859 1.171-6.45 2.23h.002l12.068 2.11c-.34.179-.545.296-.886.482l-12.845-1.882c-3.061 1.304-6.611 3.306-9.439 5.153h.002l12.64.003h.002c-.578.366-1.067.671-1.757 1.154l.012-.01-13.226.443.003.002c-2.43 1.715-4.908 3.77-6.348 5.04C6.007 24.732 1.885 28.91 0 32.668l15.424-4.014.002.002c-.694 1.023-1.258 2.088-1.591 3.038l16.751-5.307c-.175-3.908 3.618-7.398 6.196-9.516h2.126c-3.297 2.792-4.82 5.925-4.391 8.283l5.243-1.661c-1.288-3.24 2.163-9.001 10.54-11.76Zm-3.479-.571 1.025.422a36.276 36.276 0 0 0-4.62 2.22l-1.408-.23c1.257-.74 3.106-1.636 5.003-2.412Z"
      fill="#E46F26"
    />
    <path
      d="M61.408 6.048v4.472l1.506.606v.433h-4.676v-.433l1.505-.606V1.04L58.238.433V0h4.8c1.417 0 1.947.138 2.604.64.654.503 1.008 1.249 1.008 2.133 0 1.56-1.061 2.686-2.815 2.964l3.56 4.765 1.364.624v.433h-2.833l-3.88-5.511h-.638Zm0-.692h1.186c1.311 0 2.196-.989 2.196-2.427 0-1.421-.78-2.235-2.143-2.235h-1.239v4.662Zm7.49 6.204v-.433l1.506-.606v-9.48L68.9.434V0h5.294c2.285 0 3.472.416 4.535 1.578.939 1.04 1.38 2.321 1.38 3.95 0 2.098-.778 3.848-2.195 4.922-1.027.78-2.231 1.109-3.985 1.109h-5.03v.001Zm3.171-.78h1.7c1.523 0 2.338-.295 3.205-1.179.956-.988 1.381-2.202 1.381-3.9 0-1.455-.318-2.564-.991-3.448C76.566 1.196 75.592.78 73.98.78h-1.913v10h.001Zm16.774-8.077-3.258 9.029h-.727L81.282 1.04 79.918.433V0h4.48v.433l-1.346.606 2.055 6.515c.088.243.14.468.212.676.089.365.141.554.141.606.035.069.07.191.125.33L88.843 0h.798l2.515 7.608c.283.797.354 1.091.46 1.664l2.797-8.232-1.362-.607V0H98v.433l-1.382.606-4.002 10.693h-.726l-3.048-9.03Z"
      fill="#000"
    />
  </svg>
)

const HaynesPro = (props) => (
  <svg viewBox="0 0 85 20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs />
    <g transform="matrix(0.136534, 0, 0, 0.136534, 0, 0.561096)" style={{}}>
      <path d="M46.2 14.5v31.4h-20V14.5H0v85.3h26.2V66.6h20v33.2h26.2V14.5zm102.1 85.3h-23.7c-.6-2.7-.9-5.7-.9-8.9q-6.75 10.2-20.4 10.2-11.25 0-16.8-5.7c-5.55-5.7-5.6-8.2-5.6-13.2 0-6.7 3.1-12.1 9.2-16.3 6.1-4.1 16.9-6.6 32.5-7.5V57c0-2.8-.6-4.6-1.9-5.6-1.3-.9-3.1-1.4-5.6-1.4-5.7 0-9 2.3-9.6 6.9l-22.7-2.1c3-13.2 14.1-19.8 32.9-19.8q7.65 0 14.1 1.5c6.45 1.5 7.7 2.6 10.2 4.8s4.2 4.5 5 6.9c.9 2.4 1.3 7.1 1.3 13.9v25.4c.1 4.8.7 8.9 2 12.3m-25.9-29.7q-15.9 1.65-15.9 10.2 0 5.7 6.3 5.7c2.7 0 4.9-.8 6.8-2.4s2.8-5.1 2.8-10.5zm97.8-33.8-24.9 68.9c-1.9 5.2-4.7 9.3-8.2 12.2-3.6 2.9-9.1 4.4-16.6 4.4-1.8 0-9.6-.2-16.1-.6v-17.7c3.3.5 6.2.8 9 .8 7.2 0 10.7-1.6 10.7-4.7 0-1-.4-2.5-1.1-4.3l-22.8-58.9h26.7l10.5 33.9 11-33.9h21.8zm66.2 63.5h-24.9v-40q0-4.95-1.5-6.3c-1.5-1.35-2.3-1.4-3.8-1.4-4.5 0-6.8 3.2-6.8 9.5v38.2h-24.9V36.3h23.1v9c3.4-6.9 9.5-10.3 18.3-10.3q6.9 0 11.7 2.7c4.8 2.7 5.5 4.1 6.8 6.9q2.1 4.2 2.1 14.7v40.5zM337.7 77l23.2 1.6c-1.4 6.3-4.9 11.6-10.5 16s-13.3 6.6-22.9 6.6c-10.7 0-19.2-3.1-25.6-9.3s-9.6-13.9-9.6-23c0-9.5 3.1-17.5 9.4-24.1 6.3-6.5 14.7-9.8 25.2-9.8 10.2 0 18.4 3.1 24.7 9.3s9.4 14.6 9.4 25.2c0 .9 0 2.1-.1 3.6h-42.6c.1 4 .8 7 2.1 8.9s3.9 2.9 7.6 2.9c5.5-.1 8.7-2.7 9.7-7.9M336 60.5c0-4.3-.9-7.2-2.6-8.7s-3.8-2.2-6.3-2.2c-5.9 0-8.8 3.6-8.8 10.9zm28.9 21.3 19.7-2.7c1.1 4.6 5.6 6.9 13.4 6.9 6.5 0 9.7-1.2 9.7-3.7 0-1.1-.6-1.9-1.9-2.5s-4.2-1.2-8.9-1.8c-12.9-1.8-21-4.6-24.2-8.4s-4.8-8-4.8-12.7c0-6.5 2.7-11.8 8.1-15.8s12.5-6 21.3-6c15.4 0 25.2 5.6 29.5 16.7l-18.9 3.6c-1.7-3.7-5.4-5.6-11.1-5.6-2.7 0-4.7.4-6 1.1s-2 1.4-2 2.2c0 2.1 2 3.4 6 3.8 10.4 1.2 17.5 2.3 21.2 3.5s6.9 3.4 9.5 6.6 3.9 7.1 3.9 11.6c0 7-2.9 12.5-8.7 16.6s-13.8 6.1-24 6.1c-17.1-.2-27.7-6.6-31.8-19.5m83.2 17.8h-11.6V14H475c15.9 0 25.4 10.2 25.4 24.1 0 11.9-6.8 25.4-25.4 25.4h-26.9zm0-46h23c10.4 0 17.4-3.8 17.4-15.4 0-10.8-7.4-14.3-16.9-14.3h-23.5zm72.8 46h-10.5V37.3h9.9v10.4h.2c4.2-7.3 9.7-12.2 17.5-12.2 1.3 0 1.9.1 2.7.4v10.8h-3.9c-9.8 0-16 7.6-16 16.7v36.2zm57.7-64.1c19.9 0 29 16.8 29 32.9s-9.1 32.9-29 32.9-29-16.8-29-32.9 9.1-32.9 29-32.9m0 56.7c15 0 18.1-15.5 18.1-23.8s-3.1-23.8-18.1-23.8-18.1 15.5-18.1 23.8 3.1 23.8 18.1 23.8" />
      <path d="M436.4 133s86.2-7.7 171.2-6.8v-16.8s-85.9.1-171.2 9.6z" fill="#58b947" />
      <path
        clipRule="evenodd"
        d="M602.9 20.7h3V15h3.5c1 0 1.7.5 1.8 1.5v2.9c0 .5.2.9.4 1.4h3.2v-.5c-.3-.2-.6-.4-.6-1.2 0-.7-.1-2.6-.1-3.2-.2-1.3-1.1-1.7-1.6-2 1-.6 1.6-1 2-2.3s.1-2.3-.1-2.9c-.4-1.6-1.9-2.2-3.3-2.3h-8v14.3zm2.9-12h4c1.3 0 1.8.6 1.8 1.6.2 1.4-1.1 2.2-1.8 2.2h-4.1V8.7z"
        fillRule="evenodd"
      />
      <path d="M608.5 26.7c-7.4 0-13.3-6-13.3-13.3 0-7.4 6-13.3 13.3-13.3 7.4 0 13.3 6 13.3 13.3s-6 13.3-13.3 13.3m0-25.4c-6.6 0-12.1 5.4-12.1 12.1s5.4 12.1 12.1 12.1c6.6 0 12.1-5.4 12.1-12.1s-5.5-12.1-12.1-12.1" />
    </g>
  </svg>
)

const VehicleInfo = ({ className, Series, Line, Plate, Make, MakePhoto }) => {
  const [info, setInfo] = useState({})
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const { t } = useTranslation()
  const [showRdwModal, setShowRdwModal] = useState(false)

  const catalogName = getCatalogName()

  let color = useSelector((e) => e.settings.HeaderBgColor)
  let haynes = useSelector((e) => e.settings.ShowHaynesPro)

  useEffect(() => {
    if (Make) {
      info.Image = MakePhoto
      info.MakeName = ''
      info.Line = ''
      info.Series = ''
    } else {
      setLoading(true)
      fetchVehicleInfo({ plate: Plate, lineCode: Line, seriesCode: Series })
        .then((res) => {
          setInfo(res)
        })
        .catch((err) => { })
        .finally((_) => setLoading(false))
    }
  }, [Series, Line, Plate, Make])

  const onClickRdwHandler = () => {
    setShowRdwModal(true)
  }

  const handleHaynesProClick = async () => {
    // const encoder = new TextEncoder()
    // const postData = new URLSearchParams({
    //   login: 'TESTPARTSSOFT1',
    //   password: 'TestPartsSoft#1',
    //   formType: 'form1'
    // }).toString()

    // const headers = {
    //   'PS-token': new Date()
    //     .toISOString()
    //     .replace(/[^0-9]/g, '')
    //     .slice(0, 14),
    //   'Content-Length': encoder.encode(postData).length,
    //   Host: 'www.autodistribution4u.net',
    //   'User-Agent': 'Parts-Soft',
    //   Accept: '*/*',
    //   'Accept-Encoding': 'gzip, deflate, br',
    //   Connection: 'keep-alive',
    //   'Content-Type': 'application/x-www-form-urlencoded'
    // }

    // const url1 = 'https://www.autodistribution4u.net/?login=TESTPARTSSOFT1&password=TestPartsSoft#1&formType=form1'

    // try {
    //   // fetch kullanarak POST isteği
    //   const response = await fetch(url1, {
    //     method: 'POST',
    //     headers: headers,
    //     body: postData
    //   })

    //   if (!response.ok) {
    //     throw new Error(`HTTP error! status: ${response.status}`)
    //   }

    //   const data = await response.text()
    //   console.log('Response:', response.status, data)
    // } catch (error) {
    //   console.error(`Request error: ${error.message}`)
    // }

    // const kenteken = '19FZDV' // Plaka
    const redirectUrl = `https://www.autodistribution4u.net/redirectToObject?id=10077&mode=full&url=sso_connection/?objID=10077&numberPlate=${Plate}`
    // console.log('Redirect URL:', redirectUrl)

    window.open(redirectUrl, '_blank')
  }

  return (
    <>
      {loading ? (
        <Card>
          <Skeleton loading={loading} active={true}></Skeleton>
        </Card>
      ) : (
        <div className="mb-[10px]">
          <Modal footer={null} width={'100%'} open={showRdwModal} onCancel={() => setShowRdwModal(false)} onOk={() => setShowRdwModal(false)}>
            <RdwSection plate={Plate} />
          </Modal>


          <div className="flex flex-col md:flex-row justify-between relative rounded-[6px] border border-neutral-200 ">
            <div className="md:w-1/6 p-[10px] w-full flex items-center">
              <Image className="w-full object-cover object-scale-down hover:zoom"

                src={
                  catalogName === 'TECDOC'
                    ? 'https://material.parts-soft.net/webshop-media/tecdoc/' + info?.Id + '.jpg'
                    : info.Image
                }
                onError={(e) => {
                  e.target.src = ''; // Varsayılan bir resim
                }} />

            </div>

            <div className="md:w-4/6 flex flex-col items-start p-[10px] h-full">
              <div className="flex items-start w-full">
                <p className="font-bold text-[18px]" style={{ color: color }}>
                  {info.MakeName + ' ' + info.Line + ' ' + (info.Series ? info.Series : '')}
                </p>
              </div>
              <div className="md:flex md:gap-[10px] w-full">
                <div className="inline-flex flex-col items-start gap-[5px] relative flex-[0_0_auto] md:w-1/3 w-full">
                  <div className="flex w-full items-start justify-between px-[5px] py-[5px] relative bg-[#f6f7f9] rounded-[4px] overflow-hidden">
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Medium',Helvetica] font-medium text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {t('brand').replace(/./, (x) => x.toUpperCase())}
                    </div>
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {info.MakeName ? info.MakeName.toUpperCase() : ''}
                    </div>
                  </div>
                  <div className="flex w-full justify-between px-[5px] py-[5px] rounded-[4px] overflow-hidden items-start relative">
                    <div className="relative w-[96px] mt-[-1.00px] [font-family:'Poppins-Medium',Helvetica] font-medium text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {t('model').replace(/./, (x) => x.toUpperCase())}
                    </div>
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {info.Line}
                    </div>
                  </div>
                  <div className="flex w-full items-start justify-between px-[5px] py-[5px] relative bg-[#f6f7f9] rounded-[4px] overflow-hidden">
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Medium',Helvetica] font-medium text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {t('type').replace(/./, (x) => x.toUpperCase())}
                    </div>
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {info.Series}
                    </div>
                  </div>
                  <div className="flex w-full justify-between px-[5px] py-[5px] rounded-[4px] overflow-hidden items-start relative">
                    <div className="relative w-[96px] mt-[-1.00px] [font-family:'Poppins-Medium',Helvetica] font-medium text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {t('kleur').replace(/./, (x) => x.toUpperCase())}
                    </div>
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c] text-[12px] tracking-[0] leading-[normal]"></div>
                  </div>
                  <div className="flex w-full items-start justify-between px-[5px] py-[5px] relative bg-[#f6f7f9] rounded-[4px] overflow-hidden">
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Medium',Helvetica] font-medium text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {t('motor-code').replace(/./, (x) => x.toUpperCase())}
                    </div>
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {info.EngineType}
                    </div>
                  </div>
                </div>
                <div className="inline-flex flex-col items-start gap-[5px] relative flex-[0_0_auto] md:w-1/3 w-full">
                  <div className="flex w-full items-start justify-between px-[5px] py-[5px] relative bg-[#f6f7f9] rounded-[4px] overflow-hidden">
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Medium',Helvetica] font-medium text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {t('year').replace(/./, (x) => x.toUpperCase())}
                    </div>
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {(formatDate(info?.rdw?.first_admission_date)?.originalInput)}
                    </div>
                  </div>
                  <div className="flex w-full justify-between px-[5px] py-[5px] rounded-[4px] overflow-hidden items-start relative">
                    <div className="relative w-[96px] mt-[-1.00px] [font-family:'Poppins-Medium',Helvetica] font-medium text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {t('horse-power').replace(/./, (x) => x.toUpperCase())}
                    </div>
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {info.HorsePower}
                    </div>
                  </div>
                  <div className="flex w-full items-start justify-between px-[5px] py-[5px] relative bg-[#f6f7f9] rounded-[4px] overflow-hidden">
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Medium',Helvetica] font-medium text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {t('body-type').replace(/./, (x) => x.toUpperCase())}
                    </div>
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {info.BodyType}
                    </div>
                  </div>
                  <div className="flex w-full justify-between px-[5px] py-[5px] rounded-[4px] overflow-hidden items-start relative">
                    <div className="relative w-[96px] mt-[-1.00px] [font-family:'Poppins-Medium',Helvetica] font-medium text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {t('fuel-code').replace(/./, (x) => x.toUpperCase())}
                    </div>
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {info.FuelCode}
                    </div>
                  </div>
                  <div className="flex w-full items-start justify-between px-[5px] py-[5px] relative bg-[#f6f7f9] rounded-[4px] overflow-hidden">
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Medium',Helvetica] font-medium text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {t('build-start').replace(/./, (x) => x.toUpperCase())}
                    </div>
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {info.BuildStart}
                    </div>
                  </div>
                </div>
                <div className="inline-flex flex-col items-start gap-[5px] relative flex-[0_0_auto] md:w-1/3 w-full">
                  <div className="flex w-full items-start justify-between px-[5px] py-[5px] relative bg-[#f6f7f9] rounded-[4px] overflow-hidden">
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Medium',Helvetica] font-medium text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {t('build-end').replace(/./, (x) => x.toUpperCase())}
                    </div>
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {info.BuildEnd}
                    </div>
                  </div>
                  <div className="flex w-full justify-between px-[5px] py-[5px] rounded-[4px] overflow-hidden items-start relative">
                    <div className="relative mt-[-1.00px] [font-family:'Poppins-Medium',Helvetica] font-medium text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {t('line-start').replace(/./, (x) => x.toUpperCase())}
                    </div>
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {info.LineStart}
                    </div>
                  </div>
                  <div className="flex w-full items-start justify-between px-[5px] py-[5px] relative bg-[#f6f7f9] rounded-[4px] overflow-hidden">
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Medium ',Helvetica] font-medium text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {t('line-end').replace(/./, (x) => x.toUpperCase())}
                    </div>
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {info.LineEnd}
                    </div>
                  </div>
                  <div className="flex w-full justify-between px-[5px] py-[5px] rounded-[4px] overflow-hidden items-start relative">
                    <div className="relative mt-[-1.00px] [font-family:'Poppins-Medium',Helvetica] font-medium text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {t('apk-end').replace(/./, (x) => x.toUpperCase())}
                    </div>
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {info?.rdw?.apk_expiration_datetime}
                    </div>
                  </div>
                  <div className="flex w-full items-start justify-between px-[5px] py-[5px] relative bg-[#f6f7f9] rounded-[4px] overflow-hidden">
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Medium',Helvetica] font-medium text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {t('color').replace(/./, (x) => x.toUpperCase())}
                    </div>
                    <div className="relative w-fit mt-[-1.00px] [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                      {info?.rdw?.primary_color}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="inline-flex flex-col items-start justify-between relative flex-[0_0_auto] md:w-1/6 h-full">
              {Plate && (
                <div className="flex justify-center p-[10px] relative self-stretch w-full flex-[0_0_auto]">
                  <div className="inline-flex flex-row items-center p-[5px] relative flex-[0_0_auto] bg-[#1359b1] rounded-[3px_0px_0px_3px] overflow-hidden">
                    <div className="relative w-fit [font-family:'Poppins-Bold',Helvetica] font-bold text-white text-[16px] tracking-[0] leading-[24px] whitespace-nowrap">
                      NL
                    </div>
                  </div>
                  <div className="inline-flex flex-row items-center p-[5px] relative flex-[0_0_auto] bg-[#ffc501] rounded-[0px_3px_3px_0px] overflow-hidden">
                    <div className="relative w-fit [font-family:'Poppins-Bold',Helvetica] font-bold text-[#333333] text-[16px] tracking-[0] leading-[normal]">
                      {clearPlate(Plate.toUpperCase())}
                    </div>
                  </div>
                </div>
              )}
              <div className="flex p-[10px] justify-center relative self-stretch w-full flex-[0_0_auto]">
                <img className="relative self-stretch w-full flex-[0_0_auto]" style={{ height: '40px' }} src={info.Logo} />
              </div>
              <div className="flex p-[10px] justify-center relative self-stretch w-full flex-[0_0_auto]">
                <div>{Plate && <RdwLogo style={{ cursor: 'pointer' }} onClick={onClickRdwHandler} />}</div>

              </div>


              <div className="flex p-[10px] justify-center relative self-stretch w-full flex-[0_0_auto]">
                <div>
                  {haynes != 0 && (
                    <div>
                      <HaynesPro style={{ cursor: 'pointer', height: '40px' }} onClick={handleHaynesProClick} />
                    </div>
                  )}
                </div>

              </div>







            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default VehicleInfo
